import Vue from 'vue'
import VueHead from 'vue-head'

import { store } from './store/index'
import router from './router'
import vuetify from './plugins/vuetify'
import i18n from './plugins/i18n'
import './plugins/vee-validate'
import './plugins/axios'
import './plugins/vue-phone-number-input'
import './plugins/VueTimepicker'
import './plugins/vue-qrcode-reader'
import './plugins/vue-verification-code-input'
import './plugins/vue2-leaflet'
import './plugins/vue-socket'
import './registerServiceWorker'
import './prototype/index'
import MaskMoney from './directive/MaskMoney'
import MinMaskMoney from './directive/MinMaskMoney'
import MaskMoneyOnly from './directive/MaskMoneyOnly'
import MinMaskMoneyOnly from './directive/MinMaskMoneyOnly'
import App from './App.vue'

if (process.env.NODE_ENV !== 'development') {
  console.log = function() {}
}
Vue.config.productionTip = false
Vue.use(MaskMoney)
Vue.use(MinMaskMoney)
Vue.use(MaskMoneyOnly)
Vue.use(MinMaskMoneyOnly)
Vue.use(VueHead)
new Vue({
  router,
  vuetify,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
